import { bool, string } from 'prop-types';

import { getProductDisplayName } from 'shared/utils/productUtils';

const ProductName = ({ product, uppercase }) =>
  getProductDisplayName(product, uppercase);

ProductName.propTypes = {
  product: string.isRequired,
  uppercase: bool,
};

export default ProductName;
